import mixpanel from 'mixpanel-browser';
import PropTypes from 'prop-types';
import React from 'react';
import request from 'request';

import * as consts from '../../constants';
import SpinnerMessage from '../SpinnerMessage';
import { Form, Input, Select } from '../UI';

const loginModes = {
  form: 'form',
  spinner: 'spinner',
};

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: loginModes.form,
      message: 'Please log in...',
      email: '',
      password: '',
    };
  }

  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  }

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value });
  }

  handleSubmit = () => {
    this.setState({ mode: loginModes.spinner, message: consts.loggingIn });

    const { backend } = this.props;
    const { email, password } = this.state;
    this.legacyLogin(email, password, backend);
  }

  legacyLogin = (email, password, backend) => {
    // Time how long this takes
    mixpanel.time_event(consts.eventNames.legacyLogin);

    const options = {
      url: process.env.REACT_APP_LEGACY_LOGIN_URL,
      headers: {
        authorization: process.env.REACT_APP_LEGACY_LOGIN_AUTH,
      },
      json: {
        Username: email,
        Password: password,
        Backend: backend,
      },
    };

    request.post(options, (error, response, body) => {
      let success = false;
      let message = '';
      const { onLogin } = this.props;
      if (!error && response.statusCode === 200) {
        if ('ident' in body) {
          // Callback to our parent
          onLogin(email, body.ident);

          // Set the MixPanel identify now we've confirmed the user.
          mixpanel.identify(email);

          success = true;
          message = 'Okay to login';
        } else if ('error' in body) {
          this.setState({ mode: loginModes.form, message: `Login Failed: ${body.error}\n\nTry again...` });
          message = body.error;
        } else {
          this.setState({ mode: loginModes.form, message: 'Login Failed.\n\nTry again...' });
          message = 'Unknown error';
        }
      } else {
        this.setState({ mode: loginModes.form, message: 'Login Failed.\n\nTry again...' });
        message = `Network error: ${response.statusCode ? response.statusCode : 'unknown'})`;
      }

      mixpanel.track(consts.eventNames.legacyLogin, {
        success,
        message,
        email: email !== '' ? email : undefined,
      });
    });
  };

  render() {
    const { selection, onSelectionChange, applications } = this.props;
    const { email, password, mode, message } = this.state;

    return (
      <div>
        {{
          spinner: (<SpinnerMessage message={message} />),

          form: (
            <Form button="Log In" onSubmit={this.handleSubmit}>
              <p className="app-status">{message}</p>
              <Input
                label="Email:"
                type="email"
                name="email"
                value={email}
                onChangeInput={this.handleEmailChange}
              />
              <Input
                label="Password:"
                type="password"
                name="password"
                value={password}
                onChangeInput={this.handlePasswordChange}
              />
              <div>
                <Select
                  label="VU.CITY Version:"
                  name="select"
                  value={selection}
                  onChangeSelect={onSelectionChange}
                >
                  {Object.keys(applications).map((key) => (
                    <option key={key} value={key}>
                      {`${applications[key].displayName} ${
                        consts.accounts[applications[key].accountID].tag
                      }`}
                    </option>
                  ))}
                </Select>
              </div>
              <p />
            </Form>
          ),
        }[mode]}
      </div>
    );
  }
}

LoginForm.propTypes = {
  onLogin: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  applications: PropTypes.objectOf(
    PropTypes.shape({
      displayName: PropTypes.string.isRequired,
      accountID: PropTypes.string.isRequired,
    })),
  backend: PropTypes.string,
  selection: PropTypes.string,
};

LoginForm.defaultProps = {
  selection: null,
  applications: {},
  backend: null,
};

export default LoginForm;
